export const SET_CONDITION_CHECKER = 'SET_CONDITION_CHECKER'
export const RESET_CONDITION_CHECKER = 'RESET_CONDITION_CHECKER'
